import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FilePdf icon
 *
 * @category Files/Forms/Editing
 */
const FilePdf = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.135 10.706c-1.322-1.78-4.213-4.35-6.005-6.215-.667-.63-1.248-1.236-2.187-1.335-2.966 0-8.49-.642-10.652.68-1.334.84-1.865 2.372-1.791 3.892v13.963c.099 2.953-.371 4.164.988 5.82 1.829 1.977 3.423 1.36 7.142 1.483 2.867-.025 5.857.05 8.662-.037 2.743.05 4.449-2.435 4.19-5.03.012-2.99 0-7.08 0-9.872-.013-1.792.061-2.608-.297-3.25l-.062-.099zm-6.957-5.338c.235-.025.668.395 1.236.976 1.409 1.458 3.608 3.448 3.707 4.004 0 .098-.05.16-.148.21-.803.26-1.644.11-2.447.074-1.952-.173-2.496-.902-2.607-2.99 0-.742-.185-1.582.185-2.237l.087-.025zm5.672 20.858c-.519 1.087-1.668 1.557-3.67 1.532h-9.897c-2.756.235-4.77-.852-4.56-3.633.074-4.102-.16-13.048.099-17.46.284-1.952 2.372-2.36 4.077-2.36 2.04.124 4.387-.383 6.08.408.741.519.766 1.409.877 2.274.1 2.001.915 4.003 3.077 4.423 1.668.47 4.448-.148 4.275 2.336-.16 3.472.445 9.07-.308 12.332l-.062.136z"
        />
        <path
          fill="currentColor"
          d="M11.367 18q.575 0 .963.214.391.215.59.588.202.372.202.846 0 .48-.201.851a1.44 1.44 0 0 1-.597.586q-.393.211-.969.212h-.867a.4.4 0 0 1-.087-.012v1.243a.45.45 0 0 1-.901 0V18.57a.57.57 0 0 1 .57-.57zm4.518 0q.742 0 1.275.299a2 2 0 0 1 .821.853q.287.557.287 1.333 0 .777-.29 1.337a2 2 0 0 1-.828.858q-.54.298-1.298.298h-1.117a.57.57 0 0 1-.57-.57V18.57a.57.57 0 0 1 .57-.57zm6.237 0a.378.378 0 0 1 0 .756h-1.339a.57.57 0 0 0-.57.571v.21a.57.57 0 0 0 .57.571h1.12a.378.378 0 1 1 0 .755h-1.12a.57.57 0 0 0-.57.57v1.095a.45.45 0 0 1-.902 0V18.57a.57.57 0 0 1 .57-.57zm-6.485.78a.57.57 0 0 0-.57.57v2.278c0 .315.255.57.57.57h.171q.521 0 .868-.19.348-.191.523-.57.174-.383.175-.953 0-.571-.175-.949a1.2 1.2 0 0 0-.518-.566q-.34-.19-.846-.19zm-4.665-.027a.57.57 0 0 0-.57.57v1.243a.4.4 0 0 1 .086-.011h.746q.335 0 .549-.117a.74.74 0 0 0 .315-.321q.105-.204.105-.47a1 1 0 0 0-.105-.466.7.7 0 0 0-.317-.313 1.2 1.2 0 0 0-.553-.115z"
        />
      </svg>
    );
  }
);

FilePdf.displayName = 'FilePdf';

export { FilePdf };
